import { Component, OnInit } from '@angular/core';
import { SsoAuthService } from 'src/app/ecan/sso-auth.service';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-auth0-callback',
  templateUrl: './auth0-callback.component.html',
  styleUrls: ['./auth0-callback.component.scss']
})
export class Auth0CallbackComponent implements OnInit {

  public showSpinner = true;

  constructor(
    private ssoAuthService: SsoAuthService,
    private authService: AuthService,
    private router: Router) {

  }

  ngOnInit() {

    // this will check if we have a callback from Auth0 with the access token.
    // if we do then it will create the session in local storage.
    this.ssoAuthService.handleAuthentication().then(
      () => {
        this.router.navigateByUrl('/home');
      },
      (err) => {
        this.authService.handleAuthenticationError(err);
      });
  }
}
